import React, { useState } from 'react';
import Icon from 'flow/components/ui-components/Icon';

interface Props {
    routeName: string;
    routeNumber: number;
    routeUrl: string;
    routeLink: string;
    type: string;
    getLinkOnClick: (
        link: string,
        routeUrl: string,
    ) => ((e: React.MouseEvent) => void) | null;
}

const CtiLinkIcon = ({
    routeName,
    routeNumber,
    routeUrl,
    routeLink,
    type,
    getLinkOnClick,
}: Props) => {
    const [isHovered, setIsHovered] = useState(false);
    const numberIndicator = routeNumber ? `#${routeNumber} ` : '';

    return (
        <a
            href={routeUrl}
            className="flex h-7.5 cursor-pointer items-center px-1 text-white no-underline hover:bg-gray-600"
            onClick={getLinkOnClick(routeLink, routeUrl)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="mb-0.5 grow overflow-hidden text-xs font-light text-ellipsis whitespace-nowrap text-gray-300">
                {numberIndicator}
                {routeName}
            </div>
            {isHovered ? (
                // Decoration shown on hover, not an action: the link around
                // it carries both the name and the navigation.
                <span className="flex size-4.5 items-center justify-center pe-0.75 text-green-500">
                    <Icon iconKey="launch" className="size-4.5 fill-white" />
                </span>
            ) : (
                <div className="overflow-hidden text-xs font-bold text-ellipsis whitespace-nowrap text-white capitalize">
                    {type ? type.toLowerCase() : ''}
                </div>
            )}
        </a>
    );
};

export default React.memo(CtiLinkIcon);
